import { useRef } from "react";
import jwtDecode from "jwt-decode";

interface HomepageToken {
  user_id: string;
  tenant_id: string;
  role_id: string;
  api_key: string;
}

export const useHomepageSession = (token: string | null) => {
  const processedToken = useRef<string | null>(null);

  if (token && processedToken.current !== token) {
    processedToken.current = token;
    try {
      const decoded = jwtDecode<HomepageToken>(token);
      localStorage.setItem("user_id", decoded.user_id);
      localStorage.setItem("tenant_id", decoded.tenant_id);
      localStorage.setItem("role_id", decoded.role_id);
      localStorage.setItem("api_key", decoded.api_key);

      const cleanUrl = `${window.location.origin}${window.location.pathname}`;
      window.history.replaceState({}, document.title, cleanUrl);
    } catch {}
  }
};
